import { gql } from "@apollo/client";

const CREATE_USER_CONNECTION = gql`
  mutation createUserConnection($name: String, $backendInstanceIdStr: String, $heiConnectionId: Int, $dashboardUserId: String, $backendHeiId: Int)
    {createUserConnection(name: $name, backendInstanceIdStr: $backendInstanceIdStr, heiConnectionId: $heiConnectionId, dashboardUserId: $dashboardUserId, backendHeiId: $backendHeiId) {
      id
      status
      backendUserApiKey
      backendUserId
      backendUserName
      backendUserPassword
      dashboardUserId
      heiConnection
    }  
  }`
;

export default CREATE_USER_CONNECTION;
